import {RefundStatusEnum} from 'domain/usecases';
import {formatPrice} from 'presentation/utils/formatPrice';

export function formatRefundAmount(
	situationCode: RefundStatusEnum | undefined,
	amount: number | undefined,
): string {
	if (
		situationCode === RefundStatusEnum.CANCELED_4 ||
		situationCode === RefundStatusEnum.DENIED_5
	) {
		return formatPrice(0);
	}

	if (
		situationCode === RefundStatusEnum.CONCLUDED_8 &&
		typeof amount === 'number' &&
		Number.isFinite(amount)
	) {
		return formatPrice(amount);
	}

	return '--';
}
